export const scopecode = [
    {
        "commonAbbreviations": "ANL",
        "shippingCompany": "澳航",
        "remark": "畅接",
        "commonShippingAgents": "联代、顺德、航华"
    },
    {
        "commonAbbreviations": "ASL",
        "shippingCompany": "亚海",
        "remark": "畅接",
        "commonShippingAgents": "外代、中联"
    },
    {
        "commonAbbreviations": "BAL",
        "shippingCompany": "博亚",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "BLPL",
        "shippingCompany": "新加坡私立",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "BSL",
        "shippingCompany": "巴拉基",
        "remark": "畅接",
        "commonShippingAgents": "顺德"
    },
    {
        "commonAbbreviations": "BTL",
        "shippingCompany": "孟虎",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "CMA",
        "shippingCompany": "达飞",
        "remark": "畅接",
        "commonShippingAgents": "华港、联代、外运"
    },
    {
        "commonAbbreviations": "CNC",
        "shippingCompany": "正利",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "COH",
        "shippingCompany": "京汉",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "CSL",
        "shippingCompany": "晶品",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "CST",
        "shippingCompany": "宝华",
        "remark": "畅接，其实是CNC的台湾线品牌",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "CUL",
        "shippingCompany": "中联航运",
        "remark": "畅接",
        "commonShippingAgents": "振华、外运"
    },
    {
        "commonAbbreviations": "DY",
        "shippingCompany": "东映",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "EMC/EVG",
        "shippingCompany": "长荣",
        "remark": "除了MCT和HDT航线，（台湾线）不能接。 其他航线畅接",
        "commonShippingAgents": "MCT和HDT航线中联代理，其余全航线航华"
    },
    {
        "commonAbbreviations": "ESL",
        "shippingCompany": "阿联酋",
        "remark": "畅接",
        "commonShippingAgents": "全航线华港"
    },
    {
        "commonAbbreviations": "FESCO/FSC",
        "shippingCompany": "俄远东",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "GFS",
        "shippingCompany": "格飞驰",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "GLOS",
        "shippingCompany": "格洛航运",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "HAL",
        "shippingCompany": "兴亚",
        "remark": "畅接",
        "commonShippingAgents": "外运、外代、振华、锦诚"
    },
    {
        "commonAbbreviations": "HLC/HPL",
        "shippingCompany": "赫伯罗特",
        "remark": "畅接",
        "commonShippingAgents": "联代、华港、中联"
    },
    {
        "commonAbbreviations": "HLD",
        "shippingCompany": "海隆达",
        "remark": "畅接",
        "commonShippingAgents": "全航线鹏海。"
    },
    {
        "commonAbbreviations": "HMM",
        "shippingCompany": "现代",
        "remark": "畅接",
        "commonShippingAgents": "全航线鹏海。"
    },
    {
        "commonAbbreviations": "HSD/HAM",
        "shippingCompany": "汉堡南美",
        "remark": "畅接",
        "commonShippingAgents": "鹏华、航华"
    },
    {
        "commonAbbreviations": "HSLI",
        "shippingCompany": "瀚酋",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "IDL",
        "shippingCompany": "印达斯",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "KKC",
        "shippingCompany": "神原",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "KMTC/KMT",
        "shippingCompany": "高丽海运",
        "remark": "畅接",
        "commonShippingAgents": "外代、外运、中联"
    },
    {
        "commonAbbreviations": "MAT",
        "shippingCompany": "美森",
        "remark": "畅接",
        "commonShippingAgents": "全航线联代"
    },
    {
        "commonAbbreviations": "MBF",
        "shippingCompany": "卡朋特",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "MEL",
        "shippingCompany": "玛丽安娜",
        "remark": "畅接",
        "commonShippingAgents": "外运"
    },
    {
        "commonAbbreviations": "JRCW",
        "shippingCompany": "璟荣船务",
        "remark": "畅接",
        "commonShippingAgents": "全航线联代代理"
    },
    {
        "commonAbbreviations": "MSK",
        "shippingCompany": "马士基",
        "remark": "畅接",
        "commonShippingAgents": "全航线联代代理"
    },
    {
        "commonAbbreviations": "NDS",
        "shippingCompany": "尼罗河",
        "remark": "畅接",
        "commonShippingAgents": "航华"
    },
    {
        "commonAbbreviations": "NOS",
        "shippingCompany": "新东",
        "remark": "畅接，仁川线必须用NSI作为代码，宁波远洋",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "NSL",
        "shippingCompany": "宁波远洋",
        "remark": "畅接",
        "commonShippingAgents": "宁波远洋"
    },
    {
        "commonAbbreviations": "NZL",
        "shippingCompany": "新西兰航运",
        "remark": "畅接",
        "commonShippingAgents": "全航线振华"
    },
    {
        "commonAbbreviations": "OEL",
        "shippingCompany": "东速航运",
        "remark": "畅接",
        "commonShippingAgents": "东速航运"
    },
    {
        "commonAbbreviations": "ONE",
        "shippingCompany": "海洋网联",
        "remark": "畅接",
        "commonShippingAgents": "联代、华港、外运、外代、中联"
    },
    {
        "commonAbbreviations": "OOCL",
        "shippingCompany": "东方海外",
        "remark": "畅接",
        "commonShippingAgents": "东方海外"
    },
    {
        "commonAbbreviations": "PIL",
        "shippingCompany": "太平",
        "remark": "畅接",
        "commonShippingAgents": "外运、华港"
    },
    {
        "commonAbbreviations": "PMA",
        "shippingCompany": "普洱玛",
        "remark": "畅接",
        "commonShippingAgents": "全航线顺德"
    },
    {
        "commonAbbreviations": "RCL",
        "shippingCompany": "宏海箱运",
        "remark": "畅接",
        "commonShippingAgents": "顺德、外代"
    },
    {
        "commonAbbreviations": "SCI",
        "shippingCompany": "印度国航",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "SCO",
        "shippingCompany": "新加坡海运",
        "remark": "畅接，其实是边行BENLINE的子品牌",
        "commonShippingAgents": "外代、华港"
    },
    {
        "commonAbbreviations": "SLS（FCSL）",
        "shippingCompany": "新加坡海领",
        "remark": "畅接",
        "commonShippingAgents": "华港"
    },
    {
        "commonAbbreviations": "SMH",
        "shippingCompany": "司马泰",
        "remark": "畅接",
        "commonShippingAgents": "顺德"
    },
    {
        "commonAbbreviations": "SML",
        "shippingCompany": "森罗",
        "remark": "畅接",
        "commonShippingAgents": "外运、联代"
    },
    {
        "commonAbbreviations": "SNKO",
        "shippingCompany": "长锦",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "SNL",
        "shippingCompany": "外运集运",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "SOF",
        "shippingCompany": "顺发",
        "remark": "畅接",
        "commonShippingAgents": "全航线外代"
    },
    {
        "commonAbbreviations": "SSL",
        "shippingCompany": "萨姆达拉",
        "remark": "畅接",
        "commonShippingAgents": "外代"
    },
    {
        "commonAbbreviations": "STX",
        "shippingCompany": "泛奥昇",
        "remark": "畅接",
        "commonShippingAgents": "外运"
    },
    {
        "commonAbbreviations": "SUM",
        "shippingCompany": "萨米特",
        "remark": "畅接",
        "commonShippingAgents": "外运"
    },
    {
        "commonAbbreviations": "SWIP",
        "shippingCompany": "太古",
        "remark": "畅接",
        "commonShippingAgents": "鹏华、外运"
    },
    {
        "commonAbbreviations": "SWL",
        "shippingCompany": "盛威航运",
        "remark": "畅接",
        "commonShippingAgents": "外运"
    },
    {
        "commonAbbreviations": "TJM",
        "shippingCompany": "天津津海",
        "remark": "畅接",
        "commonShippingAgents": "天津津海"
    },
    {
        "commonAbbreviations": "TSL/TSC",
        "shippingCompany": "德翔",
        "remark": "中联代理的航线不能发，其他畅接",
        "commonShippingAgents": "外代、中联、顺德"
    },
    {
        "commonAbbreviations": "TYS",
        "shippingCompany": "太荣",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "UNL",
        "shippingCompany": "联合航运",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "VASI",
        "shippingCompany": "维萨航运",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "WHL",
        "shippingCompany": "万海",
        "remark": "畅接",
        "commonShippingAgents": "中联、联代 、外代、华港（台湾线民生代理）"
    },
    {
        "commonAbbreviations": "WOSCO",
        "shippingCompany": "西联",
        "remark": "畅接",
        "commonShippingAgents": "全航线外运"
    },
    {
        "commonAbbreviations": "YML",
        "shippingCompany": "阳明",
        "remark": "畅接",
        "commonShippingAgents": "外运、外代、中联、联代"
    },
    {
        "commonAbbreviations": "ZIM",
        "shippingCompany": "以星",
        "remark": "畅接",
        "commonShippingAgents": "航华、顺德"
    },
    {
        "commonAbbreviations": "POL",
        "shippingCompany": "泛洋",
        "remark": "畅接",
        "commonShippingAgents": "全航线顺德"
    },
    {
        "commonAbbreviations": "PEL",
        "shippingCompany": "普尔玛",
        "remark": "畅接",
        "commonShippingAgents": "全航线顺德"
    },
    {
        "commonAbbreviations": "CCL",
        "shippingCompany": "中通",
        // "remark": "畅接",
        // "commonShippingAgents": "全航线顺德"
    },
    {
        "commonAbbreviations": "IAL",
        "shippingCompany": "运达",
        // "remark": "畅接",
        // "commonShippingAgents": "全航线顺德"
    },
];
export const shippingAgentList = [
    {
        shippingAgent:"东方海外"
    },
    {
        shippingAgent:"锦诚"
    },
    {
        shippingAgent:"上港联合"
    },
    {
        shippingAgent:"上海航华"
    },
    {
        shippingAgent:"上海华港"
    },
    {
        shippingAgent:"上海民生"
    },
    {
        shippingAgent:"上海鹏海"
    },
    {
        shippingAgent:"上海鹏华"
    },
    {
        shippingAgent:"上海顺德"
    },
    {
        shippingAgent:"上海振华"
    },
    {
        shippingAgent:"上海中联"
    },
    {
        shippingAgent:"上海中外运"
    },
    {
        shippingAgent:"上海外代"
    }
];
export const foreignPortList = [
    {
        "foreignPort": "ACL—大西洋箱运"
    },{
        "foreignPort": "ALIANCA— 亚利安莎航运"
    },{
        "foreignPort": "ANL—澳航"
    },{
        "foreignPort": "APL—美国总统"
    },{
        "foreignPort": "CMA—达飞"
    },{
        "foreignPort": "CNC—正利"
    },{
        "foreignPort": "COSCO—中远海"
    },{
        "foreignPort": "DAL—DAL船公司"
    },{
        "foreignPort": "GOLD STAR—以星"
    },{
        "foreignPort": "GOLDEN SEA—新鑫海航运"
    },{
        "foreignPort": "HLC/HPL—赫伯罗特"
    },{
        "foreignPort": "HMM—现代"
    },{
        "foreignPort": "HSD/HAM—汉堡南美"
    },{
        "foreignPort": "MCC/SEALAND—海陆马士基"
    },{
        "foreignPort": "MSC—地中海"
    },{
        "foreignPort": "MSK—马士基"
    },{
        "foreignPort": "ONE—海洋网联"
    },{
        "foreignPort": "PANASIA—泛亚航运"
    },{
        "foreignPort": "SAF—南非航运"
    },{
        "foreignPort": "ZIM—以星"
    },{
        "foreignPort": "YML—阳明"
    },{
        "foreignPort": "EVG/EMC—长荣"
    },{
        "foreignPort": "OOCL—东方海外"
    },{
        "foreignPort": "WHL—万海航运"
    }
];
export const shanghaiPortList = [
    {
    "shanghaiPort": "ACL—大西洋箱运",
    },
    {
    "shanghaiPort": "ALIANCA— 亚利安莎航运",
    },
    {
    "shanghaiPort": "ANL—澳航",
    },
    {
    "shanghaiPort": "APL—美国总统",
    },
    {
    "shanghaiPort": "ASL—亚海",
    },
    {
    "shanghaiPort": "CL—中通海运",
    },
    {
    "shanghaiPort": "CMA—达飞",
    },
    {
    "shanghaiPort": "CNC—正利",
    },
    {
    "shanghaiPort": "COH—京汉船务",
    },
    {
    "shanghaiPort": "COSCO—中远海",
    },
    {
    "shanghaiPort": "CP—中波船代",
    },
    {
    "shanghaiPort": "CST—宝华海运",
    },
    {
    "shanghaiPort": "CUL—中联航运",
    },
    {
    "shanghaiPort": "DAL—DAL船公司",
    },
    {
    "shanghaiPort": "EVG/EMC—长荣",
    },
    {
    "shanghaiPort": "FSC/FESCO—俄远东轮船",
    },
    {
    "shanghaiPort": "GOLD STAR—以星",
    },
    {
    "shanghaiPort": "GOLDEN SEA—新鑫海航运",
    },
    {
    "shanghaiPort": "HAL—兴亚船务",
    },
    {
    "shanghaiPort": "HLC/HPL—赫伯罗特",
    },
    {
    "shanghaiPort": "HMM—现代",
    },
    {
    "shanghaiPort": "HSD/HAM—汉堡南美",
    },
    {
    "shanghaiPort": "IAL—运达航运",
    },
    {
    "shanghaiPort": "JJ—锦江航运",
    },
    {
    "shanghaiPort": "JRCW—璟荣船务",
    },
    {
    "shanghaiPort": "KKC—神原汽船",
    },
    {
    "shanghaiPort": "KMT—高丽海运",
    },
    {
    "shanghaiPort": "MAT—美森轮船",
    },
    {
    "shanghaiPort": "MCC/SEALAND—海陆马士基",
    },
    {
    "shanghaiPort": "MEL—玛利亚娜",
    },
    {
    "shanghaiPort": "MSC—地中海",
    },
    {
    "shanghaiPort": "MSK—马士基",
    },
    {
    "shanghaiPort": "NDS—尼罗河航运",
    },
    {
    "shanghaiPort": "NOS—新东海运",
    },
    {
    "shanghaiPort": "NSL—南星海运",
    },
    {
    "shanghaiPort": "NZL—新西兰海运",
    },
    {
    "shanghaiPort": "ONE—海洋网联",
    },
    {
    "shanghaiPort": "OOCL—东方海外",
    },
    {
    "shanghaiPort": "PANASIA—泛亚航运",
    },
    {
    "shanghaiPort": "PEL—帕尔玛海运",
    },
    {
    "shanghaiPort": "PMA—普洱马海运",
    },
    {
    "shanghaiPort": "RCL—宏海箱运",
    },
    {
    "shanghaiPort": "RPS—日照港海运",
    },
    {
    "shanghaiPort": "SAF—南非航运",
    },
    {
    "shanghaiPort": "SCI—印度国航",
    },
    {
    "shanghaiPort": "SCO—海运船务",
    },
    {
    "shanghaiPort": "SLS—新加坡海领船务",
    },
    {
    "shanghaiPort": "SMH—司马泰海运",
    },
    {
    "shanghaiPort": "SNKO—长锦商船",
    },
    {
    "shanghaiPort": "SOF—顺发航运",
    },
    {
    "shanghaiPort": "SSL—萨姆达拉",
    },
    {
    "shanghaiPort": "SWIR—太古轮船",
    },
    {
    "shanghaiPort": "TJM—天津津海",
    },
    {
    "shanghaiPort": "TNC—台航",
    },
    {
    "shanghaiPort": "TSL—德翔海运",
    },
    {
    "shanghaiPort": "WHL—万海航运",
    },
    {
    "shanghaiPort": "YML—阳明",
    },
    {
    "shanghaiPort": "ZIM—以星",
    },
    {
    "shanghaiPort": "PIL—太平船务",
    },
    {
    "shanghaiPort": "ALX—阿拉丁航运",
    },
    {
    "shanghaiPort": "RCC—俄集运",
    },
    {
    "shanghaiPort": "SML—森罗",  
    },
    {
    "shanghaiPort": "JRCW—璟荣船务",  
    },
    {
    "shanghaiPort": "GZZH—广州中航",  
    },
    {
    "shanghaiPort": "XMYY—厦门远洋",  
    },
    {
    "shanghaiPort": "UNL—联合航运",  
    },
    {
    "shanghaiPort": "STAROCEAN—瑞洋",  
    },
    {
    "shanghaiPort": "SWIP—太古",  
    },
    {
    "shanghaiPort": "BAL—博亚",  
    },
    {
    "shanghaiPort": "UAF—非洲联合海运",  
    },
    {
    "shanghaiPort": "GMD—越南联合海运",  
    },
    {
    "shanghaiPort": "ZGXL—上海中谷",  
    }
];